// src/FloatContactButtons.jsx
import React from "react";
import "./GlobalFloat.css";

export default function FloatContactButtons({
  // email
  mailHref = "sakcare@finance.ceptes.com",
  mailSubject = "Emergency request for transaction dispute",
  mailBody = [
    "Hello,",
    "",
    "This is an emergency request related to my recent transaction, please assist.",
    "• Customer Name: ",
    "• Account / Card #: ",
    "• Transaction Date/Time: ",
    "• Amount: ",
    "• Merchant / Reference: ",
    "",
    "Brief description of the issue:",
    "",
    "Please confirm receipt and next steps.",
    "",
    "Thanks,"
  ].join("\n"),
  mailMode = "auto", // "auto" | "outlook-web"

  // phone + chat
  phoneHref = "tel:8722666514",
  whatsappHref = "https://wa.me/15550536332?text=Hello",
  telegramHref = "https://t.me/SakCareBot",

  // icons
  iconMail,
  iconPhone,
  iconWhatsapp,
  iconTelegram,

  position = "right",
}) {
  const base = process.env.PUBLIC_URL || "";
  const icons = {
    mail: iconMail || `${base}/mail.png`,
    phone: iconPhone || `${base}/telephone.png`,
    whatsapp: iconWhatsapp || `${base}/whatsapp.png`,
    telegram: iconTelegram || `${base}/telegram.png`,
  };

  const ensureMailto = (href) => {
    if (!href) return "mailto:";
    const s = href.trim();
    if (s.toLowerCase().startsWith("mailto:")) return s;
    if (s.includes("@")) return `mailto:${s}`;
    return s;
  };

  const buildMailto = (href, subject, body) => {
    const [addr, query = ""] = ensureMailto(href).split("?");
    const params = new URLSearchParams(query);
    params.set("subject", subject);
    params.set("body", body);
    const qs = params.toString();
    return qs ? `${addr}?${qs}` : addr;
  };

  const getToAddress = (href) => {
    const m = ensureMailto(href);
    const q = m.indexOf("?");
    return m.slice("mailto:".length, q === -1 ? m.length : q);
  };

  const buildOutlookWeb = (href, subject, body) => {
    const enc = encodeURIComponent;
    const to = getToAddress(href);
    return `https://outlook.office.com/mail/deeplink/compose?to=${enc(to)}&subject=${enc(subject)}&body=${enc(body)}`;
  };

  const computedMailHref =
    mailMode === "outlook-web"
      ? buildOutlookWeb(mailHref, mailSubject, mailBody)
      : buildMailto(mailHref, mailSubject, mailBody);

  const mailTarget = mailMode === "outlook-web" ? "_blank" : undefined;
  const mailRel = mailMode === "outlook-web" ? "noreferrer" : undefined;

  return (
    <div className={`float-stack float-stack--${position}`} aria-label="Quick contact">
      {/* Email */}
      <a className="float-btn" href={computedMailHref} target={mailTarget} rel={mailRel} aria-label="Email us" title="Email">
        <img className="float-icon-img" src={icons.mail} alt="" />
      </a>

      {/* Phone */}
      <a className="float-btn" href={phoneHref} aria-label="Call us" title="Call">
        <img className="float-icon-img" src={icons.phone} alt="" />
      </a>

      {/* WhatsApp */}
      <a className="float-btn" href={whatsappHref} target="_blank" rel="noreferrer" aria-label="WhatsApp" title="WhatsApp">
        <img className="float-icon-img" src={icons.whatsapp} alt="" />
      </a>

      {/* Telegram */}
      <a className="float-btn" href={telegramHref} target="_blank" rel="noreferrer" aria-label="Telegram" title="Telegram">
        <img className="float-icon-img" src={icons.telegram} alt="" />
      </a>
    </div>
  );
}
